// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2k-q";
export var animationRelative = "_2k-p";
export var backdropBlur = "_2k-0";
export var detailLabelCell = "_2k-12";
export var detailTable = "_2k-11";
export var detailValueCell = "_2k-13";
export var docIconBox = "_2k-1d";
export var docIconBoxMd = "_2k-1f";
export var docIconBoxSm = "_2k-1e";
export var docTypeRow = "_2k-16";
export var docTypeRowInner = "_2k-17";
export var dropdownMatchDatePicker = "_2k-3";
export var evidenceCardContent = "_2k-1c";
export var fileUploadSpin = "_2k-j";
export var gorgiasOpenButton = "_2k-15 _2k-d";
export var gorgiasTicketCard = "_2k-14";
export var heroModalFooterButton = "_2k-18";
export var hiddenContainer = "_2k-o";
export var iconPrimary = "_2k-1g";
export var iconSecondary = "_2k-1h";
export var iconTertiary = "_2k-1i";
export var integrationCard = "_2k-1";
export var integrationLogoBox = "_2k-2";
export var mainColumnSticky = "_2k-1b";
export var maxWidthContainer = "_2k-19";
export var modalContentBody = "_2k-a";
export var modalHeaderImage = "_2k-5";
export var modalImageLabel = "_2k-7";
export var modalImageOverlay = "_2k-6";
export var modalImageSubtitle = "_2k-9";
export var modalImageTitle = "_2k-8";
export var modalImageWrapper = "_2k-4";
export var modalStickyFooter = "_2k-b";
export var removeButton = "_2k-e";
export var sidebarColumn = "_2k-1a";
export var spinner = "_2k-i";
export var timelineLine = "_2k-y";
export var timelineLineBlack = "_2k-10 _2k-y";
export var timelineLineGray = "_2k-z _2k-y";
export var timelineLineHeight = "_2k-x";
export var tlDotActivate = "_2k-u";
export var tlDotActivateAnim = "_2k-t";
export var tlDotHide = "_2k-s";
export var tlDotHideAnim = "_2k-r";
export var tlLineActivate = "_2k-w";
export var tlLineActivateAnim = "_2k-v";
export var uploadHint = "_2k-n";
export var uploadIconBox = "_2k-k";
export var uploadLabel = "_2k-m";
export var uploadText = "_2k-l";
export var uploadZone = "_2k-f";
export var uploadZoneCursorDefault = "_2k-h";
export var uploadZoneCursorPointer = "_2k-g";
export var uploadedFileRow = "_2k-c";
export var viewButton = "_2k-d";